<p-inputSwitch id="{{ uid }}" [(ngModel)]="value" (onChange)="handleChange()" [disabled]="isDisabled" [attr.data-testid]="uid"></p-inputSwitch>
